import React from "react";
import { toDecimal } from "../../helpers/PriceShopEngine";

type Price = {
  value: number;
  currency: string;
};

type PriceInputProps = {
  price: Price;
  allowChangeCurrency: boolean;
  onChange: (price: Partial<Price>) => void;
  readOnly?: boolean | null;
  inputClassName?: string;
};

const PriceInput: React.FC<PriceInputProps> = ({
  price,
  allowChangeCurrency = false,
  onChange,
  readOnly,
  inputClassName = "input",
}) => {
  return (
    <div className="field has-addons has-addons-left">
      <p className="control">
        <input
          name="price"
          className={inputClassName}
          type="number"
          value={toDecimal(price.value)}
          step="0.01"
          min={0}
          readOnly={readOnly ?? false}
          disabled={readOnly ?? false}
          onChange={(e) => {
            const price_with_vat = parseFloat(e.target.value ?? "");
            onChange({
              value: toDecimal(price_with_vat),
            });
          }}
        />
      </p>
      <p className="control">
        {allowChangeCurrency ? (
          <span className="control">
            <span className="select">
              <select
                disabled={readOnly ?? false}
                name="currency"
                value={price.currency}
                onChange={(e) =>
                  onChange({
                    currency: e.target.value,
                  })
                }
              >
                <option value="EUR">EUR</option>
              </select>
            </span>
          </span>
        ) : (
          <span className="is-disabled m-2 p-3">{price.currency}</span>
        )}
      </p>
    </div>
  );
};

export default PriceInput;
